import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
import AppPageOne from '@/views/app/appPageOne'
import AppPageTwo from '@/views/app/appPageTwo'
import AppPageTwoDetail from '@/views/app/appPageTwoDetail'
import Tea from '@/views/mobile/tea'
import Notice from '@/views/mobile/notice'
import National from '@/views/mobile/national'

import Tour from '@/views/mobile/tour'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: AppPageOne
    },
    {
      path: '/newInfo',
      name: 'newInfo',
      component: AppPageTwo
    },
    {
      path: '/newInfoDetail',
      name: 'newInfoDetail',
      component: AppPageTwoDetail
    },
    {
      path: '/tour',
      name: 'tour',
      component: Tour
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice
    },
    {
      path: '/national',
      name: 'national',
      component: National
    },
    {
      path: '/tea',
      name: 'tea',
      component: Tea
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js